import {TrackableEntity} from './../../fms.core/data/ChangeTrackable';

export class AmsUserPort extends TrackableEntity {
    id: number = 0;
    portID: number = 0;
    scacID: number = 0;
    code: string = '';
    portName: string = '';
    carrierName: string = '';

    constructor(init?:Partial<AmsUserPort>) {
        super();
        this.key=undefined;
        Object.assign(this, init);
    }
}
